import { Component } from '@angular/core';
import { StoreService } from '@app/shared/services/store.service';

@Component({
    selector: 'app-widget-search',
    templateUrl: './widget-search.component.html',
    styleUrls: ['./widget-search.component.scss']
})
export class WidgetSearchComponent {
    constructor( public store: StoreService) { }
}
